import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-approval-progress-badge',
  templateUrl: './approval-progress-badge.component.html',
  styleUrls: ['./approval-progress-badge.component.scss'],
  standalone: false
})
export class ApprovalProgressBadgeComponent {
  @Input() completedSteps: number | null = null;
  @Input() totalSteps: number | null = null;
  @Input() statusText: string = '';

  get shouldShowSpinner(): boolean {
    return this.totalSteps !== null && this.totalSteps > 1;
  }

  get progressText(): string {
    if (this.completedSteps !== null && this.totalSteps !== null) {
      return `${this.completedSteps}/${this.totalSteps}`;
    }
    return '';
  }

  get progressValue(): number {
    if (this.completedSteps !== null && this.totalSteps !== null && this.totalSteps > 0) {
      const zeroOffset = !this.completedSteps ? 0.25 : 0

      return ((this.completedSteps + zeroOffset) / (this.totalSteps + zeroOffset)) * 100;
    }
    return 0;
  }
}
